<template>
    <rkm-modal
        :buttons="['cancel', 'save']"
        @save="save"
        hide-header
        persistent
        ref="RkmModal"
    >
        <rkm-form ref="RkmForm">
            <rkm-row>
                <rkm-col>
                    <rkm-form-textarea
                        :validations="validations.motivo"
                        label="Motivo da evasão"
                        v-model="model.motivo"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                motivo: {max: 500},
            }
        },
    },
    created() {
        this.repositories = {
            filaAtendimento: this.getConectaSusRepository('farmacia.filaAtendimento')
        }
    },
    data: () => ({
        model: {
            id: null,
            motivo: null,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(id) {
            this.reset()

            this.model.id = id
            this.$refs.RkmModal.show()
        },
        store() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.setLoading()

                    this.repositories.filaAtendimento.evade(this.model.id, this.camelObjectKeysToSnakeRecursive(this.model))
                        .then(() => this.exit())
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        save() {
            this.store()
        },
        exit() {
            this.$refs.RkmModal.hide()
        },
        reset() {
            this.model.id = null
            this.model.motivo = null
        },
    },
    mixins: [error, repository, stringCase],
}
</script>